
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wishlist/[[...hash]]",
      function () {
        return require("private-next-pages/wishlist/[[...hash]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wishlist/[[...hash]]"])
      });
    }
  